import { getFairs } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import WeddingFairsComp from '@bridebook/web/app-basic/components/supplier/sections/wedding-fairs/wedding-fairs';
import { sortFairsByDate } from '@bridebook/web/app-shared/lib/supplier/utils/sort-fairs-by-date';

const WeddingFairs = () => {
  const fairs = useSelector(getFairs);
  const sortedFairs = sortFairsByDate(fairs);

  return <WeddingFairsComp fairs={sortedFairs} />;
};

export default WeddingFairs;
